import { render, staticRenderFns } from "./Staking.vue?vue&type=template&id=85d2669e"
import script from "./Staking.vue?vue&type=script&lang=ts"
export * from "./Staking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports